const env = (process.env.REACT_APP_DEPLOY_ENV || 'test').trim();
let keyVariables;
switch (env) {
  case 'production':
    keyVariables = (await import('./env.production')).keyVariables;
    break;
  case 'uat':
    keyVariables = (await import('./env.uat')).keyVariables;
    break;
  default:
    keyVariables = (await import('./env.test')).keyVariables;
}

export { keyVariables };
